<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import type { PlayerListEntry } from "../../../../../../admin-service-typescript-client";

    const navigate = useNavigate();
    export let player: PlayerListEntry;
</script>

<div class="card" on:click={() => navigate(player.id)}>
    <div class="card-content">
        <div class="media">
            <!-- <div class="media-left">
                <figure class="image is-48x48">
                    <img
                        src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                        alt="Placeholder"
                    />
                </figure>
            </div> -->
            <div class="media-content">
                <p class="title is-4">{player.id}</p>
                <p class="subtitle is-4">
                    {player.active ? "aktiv" : "inaktiv"}
                </p>
            </div>
            <div class="content" />
        </div>

        <div class="content" />
    </div>
</div>

<style>
    .media-content {
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .title,
    .subtitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .card {
        cursor: pointer;
        height: 100%;
    }
</style>
